import getMomentDateObj from "../functions/getMomentDateObj"
import isCurrentPerformance from "../functions/isCurrentPerformance"
import setMomentDateObjZero from "../functions/setMomentDateObjZero"

const movieFilterMixin = {
    checkFilterKey(filterKey) {
        return -1 !== ['time', 'genres', 'technical', 'fsk', 'theatreName', 'seatClasses', 'search', 'id'].indexOf(filterKey)
    },

    getActiveFilters(queryStringValues) {
        let activeFilters = {}

        Object.keys(queryStringValues).map(filterKey => {
            if(this.checkFilterKey(filterKey)) {
                const queryStringValue = queryStringValues[filterKey]
                const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
    
                if(_.has(activeFilters, filterKey)) {
                    const activeFilter = activeFilters[filterKey]
        
                    filterValues.map(filterValue => {
                        if(-1 == activeFilter.indexOf(filterValue)) {
                            activeFilters[filterKey].push(filterValue)
                        } 
                    })
                } else {
                    activeFilters[filterKey] = filterValues
                }
            }
        })

        return activeFilters
    },

    getItems(filters, dayFilters, searchFilter, activeFilters, moviesOrder, movies, activeCinema, clusterCinemaActive, today, timezone, ignoreAttributesForPerformanceFilter) { // searchFilter ist new - check
        let items = moviesOrder
        let relevantPerformances = null
        let performanceFilteredMovies = []
        let timeItems = []
        let timeFilterIsSet = false
        let moviesWithoutPerformances = []

        const hasEndDate = activeFilters && activeFilters['time'] ? _.find(activeFilters['time'], val => {
            return val.search("end") !== -1
        }) : false
        const hasStartDate = activeFilters && activeFilters['time'] ? _.find(activeFilters['time'], val => {
            return val.search("start") !== -1
        }) : false 
        
        const startDate = hasStartDate ? setMomentDateObjZero(getMomentDateObj(parseInt(hasStartDate.split(':')[1]), timezone)) : false
        const endDate = hasEndDate ? setMomentDateObjZero(getMomentDateObj(parseInt(hasEndDate.split(':')[1]), timezone)) : false
        
        Object.keys(activeFilters).map((filterKey) => {
            const filterValues = activeFilters[filterKey]

            if('time' === filterKey) {
                filterValues.map(filterValue => {
                    if(_.has(dayFilters, filterValue)) {
                        items = _.intersection(items, dayFilters[filterValue].items)
                        if(!relevantPerformances) {
                            relevantPerformances = dayFilters[filterValue].performances
                        } else {
                            relevantPerformances = _.intersection(relevantPerformances, dayFilters[filterValue].performances)
                        }
                    } else if(dayFilters && dayFilters.filterWeekDays && _.has(dayFilters.filterWeekDays, filterValue)) {
                        timeItems = _.union(timeItems, dayFilters.filterWeekDays[filterValue].items)
                        timeFilterIsSet = true
                        if(!relevantPerformances) {
                            relevantPerformances = dayFilters.filterWeekDays[filterValue].performances
                        } else {
                            relevantPerformances = _.union(relevantPerformances, dayFilters.filterWeekDays[filterValue].performances)
                        }
                    }
                })
            } else if('id' === filterKey) {
                items = _.intersection(items, filterValues)
            } else if('fsk' === filterKey && _.has(filters, filterKey)) {
                const filterKeyitems = filters[filterKey].items
                let fskItems = []
                
                filterValues.map(filterValue => {
                    if(filterKeyitems[filterValue]) {
                        fskItems = _.union(fskItems, filterKeyitems[filterValue].movies)
                    }
                })  
                
                items = _.intersection(items, fskItems)
            } else if(('theatreName'=== filterKey || 'technical' === filterKey || 'seatClasses' === filterKey) && _.has(filters, filterKey)) {
                const filterKeyitems = filters[filterKey].items
                let filterItems = []
                filterValues.map(filterValue => {
                    if(filterKeyitems[filterValue]) {
                        filterItems = _.union(filterItems, filterKeyitems[filterValue].movies)
                        if(!relevantPerformances) {
                            relevantPerformances = filterKeyitems[filterValue].performances
                        } else {
                            relevantPerformances = _.union(relevantPerformances, filterKeyitems[filterValue].performances)
                        }
                    }
                })
            
                items = _.intersection(items, filterItems)
            } else if('search' === filterKey) {
                items = _.intersection(items, searchFilter ? searchFilter.items : [])
            } else if(_.has(filters, filterKey)) {
                const filterKeyitems = filters[filterKey].items
                let filterItems = []
                filterValues.map(filterValue => {
                    if(filterKeyitems[filterValue]) {
                        filterItems = _.union(filterItems, filterKeyitems[filterValue].movies)
                    }
                })  

                items = _.intersection(items, filterItems)
            }
        })

        moviesOrder.map(moviePk => {
            const movie = movies[moviePk]
            const {performances} = movie
            
            if(performances.length === 0 && Object.keys(activeFilters).length === 0) {
                moviesWithoutPerformances.push(moviePk)
            } 
        })

        if(timeFilterIsSet) {
            items = _.intersection(items, timeItems)
        }

        // the || is relevant for cinemafilter. wouldn't work when no other filter is set besides an cinema
        if(relevantPerformances || activeCinema) {
            items.map(movieId => {
                const movie = movies[movieId]
                const {performances, technologyAttributes} = movie 
                const hasIgnoreAttribute = _.find(technologyAttributes, attribute => {
                    return _.contains(ignoreAttributesForPerformanceFilter, attribute.id) 
                }) || performances.length === 0

                const filteredForMovie = _.find(performances, performance => {
                    const {cinema, timeUtc} = performance

                    const performanceDate = getMomentDateObj(timeUtc, timezone)
                    const performanceDateZero = setMomentDateObjZero(performanceDate.clone())
                    if(isCurrentPerformance(today, performanceDate)) {
                        if(startDate || endDate) {
                            if(startDate && endDate) {
                                if(startDate.isSameOrBefore(performanceDateZero) && endDate.isSameOrAfter(performanceDateZero)) {
                                    if(relevantPerformances && !activeCinema){
                                        return _.contains(relevantPerformances, performance.id)
                                    } else if (!relevantPerformances && (activeCinema === cinema || clusterCinemaActive)) {
                                        return performance
                                    } else if(relevantPerformances && (activeCinema === cinema || clusterCinemaActive)) {
                                        return _.contains(relevantPerformances, performance.id) && (activeCinema === cinema || clusterCinemaActive)
                                    }
                                }
                            } else if(startDate && !endDate) {
                                if(startDate.isSame(performanceDateZero)) {
                                    if(relevantPerformances && !activeCinema){
                                        return _.contains(relevantPerformances, performance.id)
                                    } else if (!relevantPerformances && (activeCinema === cinema || clusterCinemaActive)) {
                                        return performance
                                    } else if(relevantPerformances && (activeCinema === cinema || clusterCinemaActive)) {
                                        return _.contains(relevantPerformances, performance.id) && (activeCinema === cinema || clusterCinemaActive)
                                    }
                                }
                            }
                        } else {
                            if(relevantPerformances && !activeCinema){
                                return _.contains(relevantPerformances, performance.id)
                            } else if (!relevantPerformances && (activeCinema === cinema || clusterCinemaActive)) {
                                return performance
                            } else if(relevantPerformances && (activeCinema === cinema || clusterCinemaActive)) {
                                return _.contains(relevantPerformances, performance.id) && (activeCinema === cinema || clusterCinemaActive)
                            }
                        }
                    }
                })

                if(!_.contains(performanceFilteredMovies, movieId) && hasIgnoreAttribute) {
                    performanceFilteredMovies.push(movieId)
                } else if(filteredForMovie && !_.contains(performanceFilteredMovies, movieId)) {
                    performanceFilteredMovies.push(movieId)
                }
            })
        }
        
        if(performanceFilteredMovies.length !== 0) {
            items = _.intersection(items, performanceFilteredMovies)
        }

        const allRelevantPks = _.union(items, moviesWithoutPerformances)
        items = _.intersection(moviesOrder, allRelevantPks)
        
        return items
    }
}

export default movieFilterMixin